"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _tokens = require("@superlogica/foundation/tokens");

var _styles = require("./styles");

var SortBy = function SortBy(_ref) {
  var fillUp = _ref.fillUp,
      fillDown = _ref.fillDown;
  var colorUp = fillUp ? _tokens.colors.neutral600 : _tokens.colors.neutral300;
  var colorDown = fillDown ? _tokens.colors.neutral600 : _tokens.colors.neutral300;
  return /*#__PURE__*/_react.default.createElement(_styles.SvgSortBy, {
    className: "table-sort-by",
    width: "10",
    height: "18",
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement(_styles.Path, {
    d: "M5 0L9.33013 6H0.669873L5 0Z",
    color: colorUp
  }), /*#__PURE__*/_react.default.createElement(_styles.Path, {
    d: "M5 18L0.669873 12L9.33013 12L5 18Z",
    color: colorDown
  }));
};

var _default = SortBy;
exports.default = _default;